import clsx from "clsx";

import { usePrettyLogEventPage } from "@components/v2/analytics";
import { useFeatureFlags } from "@hooks/http";

import { useProductAnalyticsContext } from "../hooks";

import { Tab } from "./tab";

export const Tabs = ({
  selectedCategoryCount,
  clearCategorySelected,
}: {
  clearCategorySelected: () => void;
  selectedCategoryCount: number | null;
}) => {
  const { hasFeatureFlag } = useFeatureFlags();
  const { tabState, setTabView } = useProductAnalyticsContext();

  const prettyLogEventPage = usePrettyLogEventPage();

  return (
    <div className="flex justify-between border-b border-v2-secondary">
      <div className="flex gap-4 text-sm relative ">
        {hasFeatureFlag("productAnalyticsCategoryTab") && (
          <Tab
            active={tabState.tabView === "category"}
            onClick={() => {
              prettyLogEventPage({
                domain: "Product Analytics",
                action: "onClick",
                additionalActionInfo:
                  "Change tab to Product Analytics Category",
              });
              setTabView("category");
            }}
          >
            <div className="flex gap-4 text-sm items-center">
              <div>Category</div>
              {(selectedCategoryCount || 0) > 0 && (
                <div
                  onClick={(e) => {
                    clearCategorySelected();
                  }}
                  className={clsx(
                    "text-xxs font-normal pl-3 pr-2 py-[1px] flex items-center",
                    "border border-v2-tertiary bg-cosmic-5 rounded-2xl cursor-auto truncate",
                  )}
                >
                  {Math.round(selectedCategoryCount || 0)} selected
                  <i
                    className={clsx(
                      "flex items-center justify-center ml-1 fa-regular fa-sharp",
                      "fa-xmark cursor-pointer text-v2-primary text-[1.4em] rounded-full bg-cosmic-5",
                      "px-[0.25rem] leading-[1rem]	hover:bg-cosmic-2",
                    )}
                  />
                </div>
              )}
            </div>
          </Tab>
        )}
        <Tab
          active={tabState.tabView === "product"}
          onClick={() => {
            prettyLogEventPage({
              domain: "Product Analytics",
              action: "onClick",
              additionalActionInfo: "Change tab to Product Analytics Product",
            });
            setTabView("product");
          }}
        >
          <div className="flex gap-4 text-sm items-center">
            <div>Product</div>
          </div>
        </Tab>
        <Tab
          active={tabState.tabView === "platform"}
          onClick={() => {
            prettyLogEventPage({
              domain: "Product Analytics",
              action: "onClick",
              additionalActionInfo: "Change tab to Product Analytics Platform",
            });
            setTabView("platform");
          }}
        >
          <div className="flex gap-4 text-sm items-center">
            <div>Platform</div>
          </div>
        </Tab>
        <Tab
          active={tabState.tabView === "campaign"}
          onClick={() => {
            prettyLogEventPage({
              domain: "Product Analytics",
              action: "onClick",
              additionalActionInfo: "Change tab to Product Analytics Campaign",
            });
            setTabView("campaign");
          }}
        >
          <div className="flex gap-4 text-sm items-center">
            <div>Campaign</div>
          </div>
        </Tab>
        <Tab
          active={tabState.tabView === "ad"}
          onClick={() => {
            prettyLogEventPage({
              domain: "Product Analytics",
              action: "onClick",
              additionalActionInfo: "Change tab to Product Analytics Ad",
            });
            setTabView("ad");
          }}
        >
          <div className="flex gap-4 text-sm items-center">
            <div>Ad</div>
          </div>
        </Tab>
      </div>
    </div>
  );
};
